(ns manage.content-configuration-page.db
  (:require [common.datascript.init :refer [conn]]
            [common.db.interceptors :refer [forwarded-event]]
            [datascript.core :as d]
            [manage.content-configuration-page.content-configuration.db]
            [manage.content-configuration-page.context-source.db]
            [manage.content-configuration-page.placeholder.db]
            [manage.content-configuration-page.predicate.db]
            [manage.content-configuration-page.rule.db]
            [re-frame.core :as rf]))

(def ^:private forward-events
  [{:register :get-content-function
    :events #{:resource.content-function-version/activate-version}
    :dispatch-to [:layer.adset/get-content-function]}
   {:register :import-content-function
    :events #{:resource.content-function/get-one-success}
    :dispatch-to [:manage.content-configuration-page.content-configuration.db/import]}

   {:register :set-active-version
    :events #{:resource.content-function-version/activate-version}
    :dispatch-to [:page.content-configuration/navigate-content-function-version]}
   {:register :start-retrieve-cfn
    :events #{:resource.content-function/get-one}
    :dispatch-to [:page.content-configuration/import-status :retrieving]}
   {:register :retrieve-cfn-failure
    :events #{:resource.content-function/get-one-failure}
    :dispatch-to [:page.content-configuration/import-status :failure]}
   {:register :retrieve-cfn-success
    :events #{:resource.content-function/get-one-success}
    :dispatch-to [:page.content-configuration/import-status :importing]}
   {:register :publish-state-success
    :events #{:resource.content-function/publish-stage-success}
    :dispatch-to [:resource.content-function/get-content-function-overview]}])

(rf/reg-event-fx :page.content-configuration/init
  (fn [_ _]
    {:fx [[:forward-events forward-events]
          [:dispatch [:resource.content-function/get-content-function-overview]]
          [:dispatch [:resource.schema/get-schemas]]
          [:dispatch [:resource.adset/post-preview-token]]
          [:dispatch [:page.adset-template/init]]]}))

(rf/reg-event-fx :page.content-configuration/destroy
  (fn [{:keys [db]} _]
    {:db (-> db
             (dissoc :page.content-variant
                     :page.content-configuration
                     :resource.content-function/one))
     :fx [[:page.content-configuration/unregister-mutation-listener nil]
          [:posh/transact! [[[:db/retractEntity [:content-configuration/id "default"]]]]]
          [:forward-events (map #(hash-map :unregister (:register %))
                                forward-events)]
          [:dispatch [:page.adset-template/destroy]]]}))

(rf/reg-event-fx :page.content-configuration/navigate-content-function-version
  [forwarded-event
   (rf/inject-cofx :sub [:router/path-params])
   (rf/inject-cofx :sub [:router/query-parameters-pre-coercion])
   (rf/inject-cofx :sub [:router/fragment])]
  (fn [{:router/keys [path-params query-parameters-pre-coercion fragment]} [_ version]]
    ;; Version is nil if adset was duplicated badly? See WPPODC-7997
    (when version
      {:fx [[:router/navigate! [:adset/content-configuration
                                {:params (assoc path-params :content-function-version version)
                                 :query query-parameters-pre-coercion
                                 :fragment fragment}]]]})))

(rf/reg-sub :page.content-configuration
  (fn [db _]
    (:page.content-configuration db)))

(rf/reg-event-db :page.content-configuration/import-status
  [(rf/path [:page.content-configuration :import-status])]
  (fn [_ [_ code description]]
    {code description}))

(rf/reg-sub :page.content-configuration/import-status
  :<- [:page.content-configuration]
  (fn [{:keys [import-status]} [_ code]]
    (if code
      (get import-status code)
      (first (first import-status)))))

(rf/reg-fx :page.content-configuration/register-mutation-listener
  (fn [_]
    (d/listen! conn :persist-changes
               (fn [{:keys [tx-data tempids]}]
                 (when (seq tx-data)
                   (rf/dispatch [:manage.content-configuration-page.view.save/log-unsaved-transaction tx-data (:db/current-tx tempids)])
                   (rf/dispatch [::conditionally-save-cf tx-data]))))))

(rf/reg-fx :page.content-configuration/unregister-mutation-listener
  (fn [_]
    (d/unlisten! conn :persist-changes)))

(rf/reg-event-db :page.content-configuration/set-validation-disabled
  (fn [db [_ validation-disabled?]]
    (assoc-in db [:page.content-configuration :validation-disabled] validation-disabled?)))

(rf/reg-sub :page.content-configuration/validation-disabled
  (fn [db _]
    (get-in db [:page.content-configuration :validation-disabled])))

(rf/reg-event-db :page.content-configuration/set-autosave-disabled
  (fn [db [_ autosave-disabled?]]
    (assoc-in db [:page.content-configuration :autosave-disabled] autosave-disabled?)))

(rf/reg-sub :page.content-configuration/autosave-disabled
  (fn [db _]
    (get-in db [:page.content-configuration :autosave-disabled])))

(rf/reg-sub :page.content-configuration/save-available?
  :<- [:page.content-configuration]
  (fn [{:keys [log-unsaved-transactions]} _]
    (some? log-unsaved-transactions)))

(rf/reg-event-fx :page.content-configuration/save-cf
  (fn [{:keys [db]} _]
    (let [tx-data (-> (get-in db [:page.content-configuration :log-unsaved-transactions]) vals concat flatten)]
      {:dispatch-n
       [[:manage.content-configuration-page.content-configuration.db/export]
        [:manage.content-configuration-page.context-source.db/parameter-change-update-schema-output-structure tx-data]]})))

(rf/reg-event-fx ::conditionally-save-cf
  (fn [{:keys [db]} [_ tx-data]]
    (let [auto-save? (not (get-in db [:page.content-configuration :autosave-disabled]))]
      (when auto-save?
        {:dispatch-n
         [[:manage.content-configuration-page.content-configuration.db/export]
          [:manage.content-configuration-page.context-source.db/parameter-change-update-schema-output-structure tx-data]]}))))
